<template>
	<label class="file">
		<input class="file__input" type="file" @change="handleChange" />
		<img class="file__icon" :src="require(`@/assets/images/clip.svg`)" />
	</label>
</template>

<script>
	export default {
		name: "File",
		props: {
			status: Boolean,
		},
		methods: {
			handleChange(event) {
				this.$emit("iflchange", event);
			},
		},
	};
</script>

<style lang="scss">
	.file {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 36px;
		width: 36px;
		min-width: 36px;
		border-radius: 6px;
		box-shadow: $shadowLight;
		cursor: pointer;
		overflow-x: hidden;

		&__input {
			position: absolute;
			width: 0;
			height: 0;
			opacity: 0;
			overflow: hidden;
			z-index: -1;
		}

		&__icon {
			width: 16px;
		}
	}
</style>
